module.exports = __webpack_public_path__ + "img/veranda-rideau.74707256.jpg";